var render = function render(){var _vm=this,_c=_vm._self._c;return _c('EmptyStates',{attrs:{"description":"No data to display"}})
}
var staticRenderFns = []

export { render, staticRenderFns }